import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

type IProps = {
  handleTrashClick: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
  onFocus?: (event: React.FocusEvent<SVGSVGElement>) => void;
  onlyHover?: boolean;
  label: ReactNode;
  showTrash: boolean;
};

export const TrashLabel: React.FC<IProps> = (props) => {
  return (
    <HeaderWrapper>
      {props.label}
      {props.showTrash && props.label && (
        <Trash icon={faTrash} onClick={props.handleTrashClick} $onlyHover={!!props.onlyHover} onFocus={props.onFocus} />
      )}
    </HeaderWrapper>
  );
};

const Trash = styled(FontAwesomeIcon)<{ $onlyHover: boolean }>`
  color: ${(props) => (props.$onlyHover ? '#9CA3AF' : '#E5E7EB')};
  padding: 6px;
  cursor: pointer;
  visibility: ${(props) => (props.$onlyHover ? 'hidden' : 'visible')};
  font-size: 14px;
  transition: all 0.2s ease;
  border-radius: 4px;

  &:hover {
    color: #ef4444;
    background-color: ${(props) => (props.$onlyHover ? '#FEE2E2' : 'rgba(254, 226, 226, 0.3)')};
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;

  &:hover ${Trash} {
    visibility: visible;
  }
`;
